/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationBankDataAliases {
  FETCH_BANK_DATA = 'fetch-bank-data',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_ACCOUNT = 'field-account',
  FIELD_ACCOUNT_DIGIT = 'field-account-digit',
  FIELD_AGENCY_DIGIT = 'field-agency-digit',
  FIELD_BANK_AGENCY = 'field-bank-agency',
  FIELD_DS_BANK = 'field-dsBank',
  FIELD_GHOST = 'field-ghost',
  FIELD_GHOST_2 = 'field-ghost-2',
  FIELD_LOCATOR = 'field-locator',
  FIELD_MESSAGE = 'field-message',
  FORM_0 = 'form-0',
  FORM_BANK_DATA = 'form-bank-data',
  INPUT_0 = 'input-0',
  INPUT_ACCOUNT = 'input-account',
  INPUT_ACCOUNT_DIGIT = 'input-account-digit',
  INPUT_AGENCY_DIGIT = 'input-agency-digit',
  INPUT_BANK_AGENCY = 'input-bank-agency',
  LAYOUT_BANK_DATA = 'layout-bank-data',
  LOCATOR_0 = 'locator-0',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_10 = 'mapper-10',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_PENDENCIES = 'panel-pendencies',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TOAST_PENDENCIES = 'toast-pendencies',
}
export { AccreditationBankDataAliases };
